import { render } from "./RiWidgetNew.vue?vue&type=template&id=1a8345bf"
import script from "./RiWidgetNew.vue?vue&type=script&lang=js"
export * from "./RiWidgetNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWidgetNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a8345bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a8345bf', __exports__)) {
    api.reload('1a8345bf', __exports__)
  }
  
  module.hot.accept("./RiWidgetNew.vue?vue&type=template&id=1a8345bf", () => {
    api.rerender('1a8345bf', render)
  })

}


export default __exports__